/** Максимальный размер загружаемого изображения на клиенте (10 МиБ) */
export const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024;

/**
 * @param {File} file
 * @throws {Error} если файл слишком большой или не передан
 */
export function assertImageFileMaxSize(file) {
  if (!file || typeof file.size !== 'number') {
    throw new Error('Файл не выбран');
  }
  if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
    const mb = (file.size / (1024 * 1024)).toFixed(1);
    throw new Error(`Размер изображения не должен превышать 10 МБ (выбрано ${mb} МБ)`);
  }
}
